import layout from '@/views/common/layout'
const passportRoute = [
    {
        path: '/passport',
        component: layout,
        children: [
            {
              path: 'login',
              component: () => import('@/views/passport/login'),
              name: 'login',
              meta: { title: '登录',  affix: true }
            },
            {
                path: 'modifyPass',
                component: () => import('@/views/passport/modifyPassport'),
                name: 'modifyPass',
                meta: { title: '修改密码', affix: true }
              },
            {
              path: 'resetPassword',
              component: () => import('@/views/passport/resetPassword'),
              name: 'resetPassword',
              meta: { title: '重置密码',  affix: true,requireAuth: true }
            }
      ]
    }
]

export default passportRoute



// WEBPACK FOOTER //
// ./src/router/modules/passport.js